module.exports = __webpack_public_path__ + "static/media/Dra-Marisol-Vazquez.4bce88f6.jpg";